const base = process.env.REACT_APP_IMG_URL;

export const thumbUrl = (app, src, width, height) => {
  const options = 'i:true,cg:true,ft:cover?cache=true';
  return `${base}/${app}/${src}/:/rs=w:${width},h:${height},${options}`;
}